// Single source of truth for hiring/job-listing display labels.
// Imported by /hiring/[slug] (role detail) and the hiring browse shell
// (card list). Keys match the values written by HiringForm.

export const POSITION_LABELS: Record<string, string> = {
  full_time: "Full-time",
  part_time: "Part-time",
  weekends: "Weekends",
  flexible: "Flexible",
  contract: "Contract",
}

export const COMPENSATION_LABELS: Record<string, string> = {
  booth_rental: "Booth rental",
  commission: "Commission",
  both: "Both",
  hourly: "Hourly",
  salary: "Salary",
}

export const SPECIALTY_LABELS: Record<string, string> = {
  fades: "Fades",
  beards: "Beards",
  color: "Color",
  curly_textured: "Curly / textured",
  kids: "Kids",
  long_hair: "Long hair",
  skin_fades: "Skin fades",
  razor_work: "Razor work",
}

export const EXPERIENCE_LABELS: Record<string, string> = {
  any: "Any experience",
  "1plus": "1+ years",
  "3plus": "3+ years",
  "5plus": "5+ years",
  master: "Master",
}

export const CLIENTELE_LABELS: Record<string, string> = {
  building: "Building clientele",
  established: "Established clientele",
  large_following: "Large following",
  walk_in_ready: "Walk-in ready",
}
